import { is } from 'date-fns/locale';
import { conciliationReportsAxios, thirdPartyAxios } from '../config/axiosInstances';

export interface SynchroFilterRequest {
  countryAcronym: string | null | undefined;
  storeAcronym?: string | undefined;
  stores?: string | undefined;
  accountingDateRange?: string;
  dateFrom?: string;
  dateTo?: string;
  isSentToOnedrive?: boolean;
}

export interface FindSynchroLogResponseItem {
  country_date: string;
  store_integration_timestamp: string;
  country: string;
  store: string;
  integration_name: string;
  accounting_date: string;
  message: string;
  sent: string;
  created_date: string;
  created_by: string;
  ttl: number;
  justification: string;
}

export type FindSynchroLogResponse = FindSynchroLogResponseItem[];

export interface ExecuteSynchroRequest {
  countryAcronym: string;
  stores: string;
  businessDateFrom: string;
  businessDateTo: string;
  justification: string;
}

export default class SynchroApi {
  static async findSynchroHistory(request: SynchroFilterRequest) {
    const params: Record<string, string | undefined> = {
      country: request.countryAcronym ?? undefined,
      stores: request.stores || request.storeAcronym,
      dateFrom: request.dateFrom || undefined,
      dateTo: request.dateTo || undefined,
      isSentToOnedrive: request.isSentToOnedrive ? 'true' : 'false',
    };

    return conciliationReportsAxios.get<FindSynchroLogResponse>('/synchro-history', { params });
  }

  static async executeSynchro(data: ExecuteSynchroRequest) {
    return thirdPartyAxios.post('/synchro-execute', data);
  }
}

export const synchroHistoryRequestMap = (
  payload: SynchroFilterRequest,
  sendToOndrive?: boolean
) => ({
  ...payload,
  sendToOndrive: Boolean(sendToOndrive),
});
